import type { FC, MouseEvent } from 'react';
import { memo } from 'react';

import { BaseStepCountStepStyled } from './styles/BaseStepCountStepStyled'
import { type StepCountCommonProps, type StepStatus } from '../../types'

export interface IBaseStepCountStepInnerProps {
  stepIndex: number
  stepStatus: StepStatus
  onClick: (event: MouseEvent<HTMLLIElement>) => void
}

export interface IBaseStepCountStepProps
  extends StepCountCommonProps<IBaseStepCountStepInnerProps> {}

export const BaseStepCountStep: FC<IBaseStepCountStepProps> = memo(
  ({ children, stepCountProps: { clickable }, innerProps }) => {
    return (
      <BaseStepCountStepStyled
        className={innerProps.stepStatus}
        clickable={clickable}
        onClick={innerProps.onClick}
      >
        {children}
      </BaseStepCountStepStyled>
    )
  }
)

BaseStepCountStep.displayName = 'BaseStepCountStep'
